import React from 'react';

const InsightCard = ({ type, data, isActive, isFocused }) => {
  const renderCustomerCard = () => (
    <div className="card-content">
      <div className="metric-header">
        <span>Total customer</span>
        <span className="growth-badge">{data.growth} from last week</span>
      </div>
      <div className="main-value">{data.totalCustomer}</div>
      <div className="historical-values">
        <div className="historical-item">
          <span>Previous week</span>
          <span>{data.previousWeek}</span>
        </div>
        <div className="historical-item">
          <span>Last week</span>
          <span>{data.lastWeek}</span>
        </div>
      </div>
    </div>
  );

  const renderValueCard = () => (
    <div className="card-content value-card">
      <div className="value-item">
        <span>Target value</span>
        <span className="value">{data.targetValue}</span>
      </div>
      <div className="value-item">
        <span>Actual value</span>
        <span className="value">{data.actualValue}</span>
      </div>
    </div>
  );

  const cardClassName = `insight-card ${isFocused ? 'focused' : 'blurred'}`;

  return (
    <div className={cardClassName}>
      <div className="card-header">
        <span>{data.title}</span>
        <div className="toggle-container">
          <input type="checkbox" className="toggle" defaultChecked />
        </div>
      </div>
      {type === 'customer' ? renderCustomerCard() : renderValueCard()}
    </div>
  );
};

export default InsightCard;